import * as React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api.service';
import GeneralConstants from '../../constants/general.constants';

const Dashboard = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                setLoading(true);
                const response = await api.users.get('?isAdmin');
                setIsAdmin(response.isAdmin);
            } catch (error) {
                console.error('Failed to check admin status:', error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };
        
        checkAdminStatus();
    }, []);
    
    return (
        <div className='dashboard-container'>
            <Link to='/project-add' className='dashboard-item dashboard-item--add-project'>
                <span>{GeneralConstants['add_project']}</span>
            </Link>
            <Link to='/project-active' className='dashboard-item dashboard-item--active-projects'>
                <span>{GeneralConstants['active_projects']}</span>
            </Link>
            <Link to='/project-archive' className='dashboard-item dashboard-item--project-archive'>
                <span>{GeneralConstants['archive_projects']}</span>
            </Link>
            <Link to='/my-day' className='dashboard-item dashboard-item--my-day'>
                <span>{GeneralConstants['my_day']}</span>
            </Link>
            <Link to='/calendar' className='dashboard-item dashboard-item--calendar'>
                <span>{GeneralConstants['calendar']}</span>
            </Link>
            <Link to='/map' className='dashboard-item dashboard-item--map'>
                <span>{GeneralConstants['map']}</span>
            </Link>
            <Link to='/project-log' className='dashboard-item dashboard-item--project-log'>
                <span>{GeneralConstants['project_log']}</span>
            </Link>
            {isAdmin && (
                <Link to='/admin-user' className='dashboard-item dashboard-item--settings'>
                    <span>{GeneralConstants['settings']}</span>
                </Link>
            )}
        </div>
    );
};

export default Dashboard;